import { createFileRoute, Outlet, useParams } from '@tanstack/react-router'
import { AllergensWidget } from '@/widgets/allergens-widget'

export const Route = createFileRoute(
  '/_auth/canteen/meal-restrictions/restriction/$restrictionId/allergens'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { restrictionId } = useParams({
    from: '/_auth/canteen/meal-restrictions/restriction/$restrictionId/allergens',
  })

  return (
    <>
      <AllergensWidget taskId={restrictionId} basePath="canteen" />
      <Outlet />
    </>
  )
}
